export default "__VITE_ASSET__D$1Ie7YT__"